export default __webpack_public_path__ + "assets/pt_bg.1615690a.svg";